import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/platform-browser';
let SvgIconComponent = /*#__PURE__*/(() => {
  class SvgIconComponent {
    constructor(httpClient, sanitizer, changeDetector) {
      this.httpClient = httpClient;
      this.sanitizer = sanitizer;
      this.changeDetector = changeDetector;
      this.style = {};
      this.styleClass = '';
    }
    ngOnChanges() {
      this.loadResource();
    }
    getIconUrl() {
      if (this.srcUrl) {
        return this.srcUrl;
      } else if (this.name) {
        return `assets/${this.name}.svg`;
      }
      throw new Error('neither name nor srcUrl passed');
    }
    loadResource() {
      const url = this.getIconUrl();
      this.httpClient.get(url, {
        responseType: 'text'
      }).subscribe(value => {
        this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
        this.changeDetector.markForCheck();
      });
    }
  }
  SvgIconComponent.ɵfac = function SvgIconComponent_Factory(t) {
    return new (t || SvgIconComponent)(i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(i2.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  SvgIconComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SvgIconComponent,
    selectors: [["pv-svg-icon"]],
    inputs: {
      name: "name",
      srcUrl: "srcUrl",
      style: "style",
      styleClass: "styleClass"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 1,
    vars: 4,
    consts: [[1, "pv-svg-icon", "w-1rem", "h-1rem", 3, "ngStyle", "innerHTML"]],
    template: function SvgIconComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.styleClass);
        i0.ɵɵproperty("ngStyle", ctx.style)("innerHTML", ctx.svgIcon, i0.ɵɵsanitizeHtml);
      }
    },
    dependencies: [i3.NgStyle],
    styles: [".pv-svg-icon>svg{width:100%;height:100%}\n"],
    encapsulation: 2
  });
  return SvgIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SvgIconModule = /*#__PURE__*/(() => {
  class SvgIconModule {}
  SvgIconModule.ɵfac = function SvgIconModule_Factory(t) {
    return new (t || SvgIconModule)();
  };
  SvgIconModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SvgIconModule
  });
  SvgIconModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [HttpClientModule, CommonModule]
  });
  return SvgIconModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var publicApi = {};

/**
 * Generated bundle index. Do not edit.
 */

export { SvgIconComponent, SvgIconModule };
